<template>

<div class="main account-payments">

	<div class="sub-header">
		<h1>Account Payments</h1>
	</div>

	<div class="list-view">

		<div class="filters">
			<div class="button action" @click="saveClientBilling()">Save Billing</div>
			<div v-if="getDevEnvironment" class="divider"></div>
			<div v-if="getDevEnvironment" class="extra-menu-item" @click="getClientAccount()">Reload</div>
		</div>

		<div class="detail no-sidebar no-sub-header">

			<loading v-if="loading"></loading>
			<div v-else>

				<!-- <div v-if="subscription.internal_use_only">
					<h3>Payment account needs to be updated</h3>
					<p>There was a problem with your most recent subscription payment. Use the <b>update card on file</b> button below to enter new credit card info.</p>
					<p>The updated card will be charged ${{ subscription.amount }} now to bring the subscription up to date. Subsequent subscription payments will be billed automatically.</p>
				</div> -->

				<div class="two-one-columns">
					<div>
						<payment-inputs :billing="subscription" :showTypeControls="false" :key="'payment_inputs_' + subscription.subscription_id" />
					</div>
					<div style="margin: 0 0 0 2em;">
						<h2>Subscription Info</h2>
						<div v-if="!subscription.subscription_id" style="margin: 1em 0; font-weight: bold;">
							No payment account on file
						</div>
						<label>Subscription Amount</label>
						<input type="text" v-model="subscription.amount" :disabled="!getAdministratorFlag">
						<label>Billing Frequency</label>
						<select v-model="subscription.subscription_frequency_id" :disabled="!getAdministratorFlag">
							<option value="">Select...</option>
							<option v-for="(frequency, id) in subscriptionFrequencies" :value="id">{{ frequency }}</option>
						</select>
						<label>Start Date</label>
						<input type="date" v-model="subscription.start_date" :disabled="!getAdministratorFlag">
						<div v-if="subscription.subscription_frequency_id == 1">
							<label>Billing Day</label>
							<select v-model="subscription.subscription_day" :disabled="!getAdministratorFlag">
								<option value="">Select...</option>
								<option v-for="day in billingDays" :value="day">{{ day }}</option>
							</select>
						</div>
						<label>Next Payment Date</label>
						<input type="date" v-model="subscription.next_payment_date" :disabled="true">

					</div>
				</div>
				<div class="v-spaced">
					<h2>Payment History</h2>
					<div v-if="paymentHistory.length == 0" style="margin: 1em 0; font-weight: bold;">
						No payment history
					</div>
					<table v-else class="data-list payment-list" cellpadding="0" cellspacing="0">
						<thead>
							<tr>
								<th class="list">Date</th>
								<th class="list">Description</th>
								<th class="list">Number</th>
								<th class="list">Amount</th>
								<th class="list">Transaction ID</th>
								<th class="list">Auth Code</th>
								<th class="list center">Status</th>
								<th class="list"></th>
							</tr>
						</thead>
						<tr v-for="(payment, index) in paymentHistory" class="list">
							<td class="list">{{ payment.payment_date }}</td>
							<td class="list">{{ payment.description }}</td>
							<td class="list">{{ payment.reference_number }}</td>
							<td class="list">${{ payment.amount }}</td>
							<td class="list">{{ payment.transaction_identifier }}</td>
							<td class="list">{{ payment.authorization_code }}</td>
							<td class="list center"><i :class="['fa', payment.response_code == '100' && payment.authorization_code ? 'fa-check' : 'fa-times error']"></i></td>
							<td v-if="showPaymentButton(payment)" class="list">
								<div :class="['button', saving ? 'disabled' : 'neutral', 'inline']" style="width: 10em; margin: 0.5em 0;" @click="confirmDoPayment(payment)">{{ payment.response_code == '100' && payment.authorization_code ? "Refund" : "Retry" }}</div>
							</td>
							<td v-else class="list" style="font-size: 0.8em; width: 5em; height: 2.75em;">{{ showPaymentLabel(payment) }}</td>
						</tr>
					</table>
				</div>
			</div>
		</div>
	</div>

	<message-modal v-if="message" :message="message" :loading="loading" :errorStatus="messageStatus" :timeout="messageTimeout" @dismiss="message = ''" />

</div>

</template>

<script>
import LabelRequired from '@/components/LabelRequired.vue'
import StateSelect from '@/components/StateSelect.vue'
import ToolTip from '@/components/ToolTip.vue'
import PaymentInputs from '@/components/PaymentInputs.vue'
export default {
    name: 'account-payments',
    components: {
        'label-required': LabelRequired,
        'state-select': StateSelect,
		'tool-tip': ToolTip,
		'payment-inputs': PaymentInputs
    },
    data() {
        return {
            loading: true,
            message: '',
			messageStatus: '',
			messageTimeout: 0,
			clientAccount: {},
			subscription: {},
			paymentHistory: [],
			subscriptionFrequencies: [],
			billingDays: Array.from({length: 28}, (v, k) => k + 1),
			saving: false
        }
    },
    created() {
        this.getClientAccount()
    },
	computed: {
	},
    methods: {
		getClientAccount() {
            this.apiCall({ destination: 'get_item_client_account' }).then(obj => {
                this.clientAccount = obj.account
				this.subscription = obj.subscription
				this.subscriptionFrequencies = obj.subscription_frequencies
				this.paymentHistory = obj.payment_history
				this.loading = false
            }).catch(err => {
                console.log(err);
            })
		},
		showPaymentButton(payment) {
			return this.getAdministratorFlag && payment.amount > 0 && payment.gateway_response.indexOf('REFUNDED') < 0 && payment.gateway_response.indexOf('REPROCESSED') < 0
		},
		showPaymentLabel(payment) {
			if (payment.gateway_response) {
				let gatewayResponse = JSON.parse(payment.gateway_response)
				return gatewayResponse.status.capitalizeWords()
			} else {
				return payment.authorization_code ? 'Authorized' : 'Unknown'
			}
		},
		saveClientBilling() {
			if (this.saving) { return }
			this.saving = true
			this.messageStatus = ''
			this.message = 'Saving billing address...'
            this.apiCall({ destination: 'save_item_subscription', data: { subscription: this.subscription } }).then(obj => {
				this.saving = false
				this.messageStatus = obj.status
				if (obj.status == 'success') {
					this.message = 'Billing address saved!'
					this.messageTimeout = 1500
				} else {
					this.message = obj.message
				}
            }).catch(err => {
                console.log(err);
            })
		}
    }
}
</script>

<style lang="scss" scoped>
</style>
